import { getUnixTimestampAndAddDays } from '@tgg/util';

export const getPromoTimes = (
    promoStartDate: string | undefined,
    promoEndDate: string | undefined,
) => ({
    startDate: getUnixTimestampAndAddDays(promoStartDate, 0),
    endDate: getUnixTimestampAndAddDays(promoEndDate, 1),
});
